'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
  CommunityMatrimonyServices,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

const faqItems = [
  { question: 'How to join the Kumbhar Matrimony WhatsApp Group Link?', answer: 'Due to the privacy policy, MarathiVadhuVarSuchak.com does not have a WhatsApp Group Link to join.' },
  { question: 'How to do the Kumbhar Matrimony Login online?', answer: 'Kumbhar Vadhu Var can register for free through MarathiVadhuVarSuchak.com. After approval, you can log in with your credentials.' },
  { question: 'How to search the Kumbhar Matrimony Grooms online?', answer: 'To search Kumbhar Matrimony Grooms online, you have to register on MarathiVadhuVarSuchak.com.' },
  { question: 'Which is the best Kumbhar Matrimony Pune?', answer: 'MarathiVadhuVarSuchak.com is the best Kumbhar Matrimony for the Pune region.' },
  { question: 'Which is the trusted Kumbhar Matrimony Maharashtra?', answer: 'MarathiVadhuVarSuchak.com is the most trusted Kumbhar Matrimony in the state of Maharashtra.' },
  { question: 'How to search for the Kumbhar Matrimony Brides?', answer: 'You can register for free on MarathiVadhuVarSuchak.com to search for the Kumbhar Matrimony Brides online.' },
  { question: 'How to search Lingayat Kumbhar Matrimony profiles?', answer: 'MarathiVadhuVarSuchak.com is a trusted Marathi matrimonial site for searching Lingayat Kumbhar Matrimony profiles.' },
  { question: 'How to search for the Kumbhar Vadhu Pune?', answer: 'To search Pune-based Kumbhar Vadhu profiles, you need to register for free on MarathiVadhuVarSuchak.com Marathi matrimonial site.' },
  { question: 'How to search for Kumbhar Vadhu Var online?', answer: 'To search verified Kumbhar Vadhu Var profiles online, visit MarathiVadhuVarSuchak.com matrimony.' },
  { question: 'How to attend the Kumbhar Vadhu Var Melava?', answer: 'MarathiVadhuVarSuchak.com Marathi matrimony organizes time-to-time Vadhu Var Melava in Maharashtra. So, keep visiting site for the latest updates.' },
  { question: 'Which is the best Lingayat Kumbhar Vadhu Var Suchak Mandal?', answer: 'MarathiVadhuVarSuchak.com is the best Lingayat Kumbhar Vadhu Var Suchak Mandal in Maharashtra.' },
  { question: 'Which is the best Kumbhar Vadhu Var Suchak Mandal in Pune?', answer: 'For Pune-based Kumbhar Samaj Vadhu Var, MarathiVadhuVarSuchak.com is the trusted Kumbhar Vadhu Var Suchak Mandal.' },
  { question: 'How to join the Kumbhar Samaj Vadhu Var WhatsApp Group Link?', answer: 'No! Because of the privacy policy, MarathiVadhuVarSuchak.com does not have a WhatsApp Group Link to join.' },
  { question: 'How to get Kumbhar Samaj Vadhu Var Mahiti?', answer: 'Visit MarathiVadhuVarSuchak.com matrimonial to get Kumbhar Samaj Vadhu Var information.' },
  { question: 'Which is the best Kumbhar Samaj Matrimony in Nashik?', answer: 'MarathiVadhuVarSuchak.com is the best Kumbhar Samaj Matrimony in Nashik.' },
  { question: 'Which is the best Kumbhar Samaj Vadhu Var Suchak Mandal in Mumbai?', answer: 'MarathiVadhuVarSuchak.com is the most trusted Kumbhar Samaj Vadhu Var Suchak Mandal in Mumbai.' },
  { question: 'Which is the trusted Kumbhar Samaj Pune Vadhu Var Suchak?', answer: 'In Pune city, MarathiVadhuVarSuchak.com is the trusted Kumbhar Samaj Vadhu Var Suchak.' },
  { question: 'How to search Kokisare Kumbhar Samaj Vadhu Var Profiles?', answer: 'Visit MarathiVadhuVarSuchak.com Marathi matrimonial site, to search Kokisare Kumbhar Samaj Vadhu Var Profiles.' },
  { question: 'Which is the best Kumbhar Samaj Pune Maharashtra based Matrimonial site?', answer: 'MarathiVadhuVarSuchak.com Marathi matrimonial is the trusted Kumbhar Samaj Pune-based Marathi Vadhu Var Suchak.' },
  { question: 'How to search for Kumbhar grooms online?', answer: 'Visit MarathiVadhuVarSuchak.com portal to search for Kumbhar Samaj grooms.' },
  { question: 'Which is the best matrimony for Kumbhar Caste Vadhu Var search?', answer: "'Marathi Vadhu Var Suchak' is the best matrimony for Kumbhar Caste Vadhu Var profiles search." },
];

const communityServices: { label: string; href?: string }[] = [
  { label: "Kumbhar Matrimony WhatsApp Group Link" },
  { label: "Kumbhar Matrimony Login" },
  { label: "Kumbhar Matrimony Grooms" },
  { label: "Kumbhar Matrimony Pune" },
  { label: "Kumbhar Matrimony Maharashtra" },
  { label: "Kumbhar Matrimony Brides" },
  { label: "Lingayat Kumbhar Matrimony" },
  { label: "Kumbhar Vadhu Pune" },
  { label: "Kumbhar Vadhu Var" },
  { label: "Kumbhar Vadhu Var Melava" },
  { label: "Lingayat Kumbhar Vadhu Var Suchak" },
  { label: "Kumbhar Vadhu Var Suchak Mandal" },
  { label: "Kumbhar Samaj Vadhu Var WhatsApp Group Link" },
  { label: "Kumbhar Samaj" },
  { label: "Kumbhar Samaj Vadhu Var Mahiti" },
  { label: "Kumbhar Samaj Matrimony" },
  { label: "Kumbhar Samaj Vadhu Var Suchak Mandal" },
  { label: "Kumbhar Samaj Pune" },
  { label: "Kumbhar Samaj Mumbai" },
  { label: "Kumbhar Samaj Vadhu Var Suchak" },
  { label: "Kumbhar Samaj Vadhu Var" },
  { label: "Kumbhar Samaj Mahiti in Marathi" },
  { label: "Kumbhar Samaj Vadhu Var Suchak Mandal in Mumbai" },
  { label: "Kumbhar Samaj Itihaas" },
  { label: "Kokisare Kumbhar Samaj" },
  { label: "Kumbhar Samaj Pune Maharashtra" },
  { label: "Kumbhar Samaj WhatsApp group" },
  { label: "Kumbhar Samaj itihas" },
  { label: "Kumbhar Samaj Vadhu" },
  { label: "Kumbhar grooms" },
  { label: "Kumbhar Caste" },
];

export default function KumbharMatrimonyClient() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      <Header variant="transparent" />

      <HomeHeroSection
        title="कुंभार समाजातील वधू वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="kumbhar_matrimony"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Frequently Asked Questions</h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {faqItems.map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">{faq.question}</h3>
                    <svg className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${openFAQ === index ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div className={`px-6 transition-all duration-300 ease-in-out ${openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CommunityMatrimonyServices
        title="Kumbhar Matrimony for Kumbhar Communities"
        items={communityServices}
      />

    </div>
  );
}
